// API Utilties

import store from "@/store/store";
import * as Utils from "@/utils/utils.js";
import { m } from "@/utils/utils";
import { eventBus } from '@/main';
import Vue from 'vue';
// import VueResource from 'vue-resource';


// Format HTTP Request Package ==========
export const buildFormPkg = (dat) => {
	m("build form package");

	let form_name = dat.form_name; 
	let form_fields = {};
	let cfg_form = {};
	let pkg = { 
		ok: true,
		mess: [],
	};

	// Common form fields
	let state = store.getters["api/state"];
	cfg_form = state.CfgForms.all;

	for (let key in cfg_form) {
		let val = cfg_form[key];
		form_fields[key] = val;
	}

	// Default form fields
	cfg_form = state.CfgForms[form_name];
	if (typeof cfg_form != "undefined") {
		for (let key in cfg_form) {
			let val = cfg_form[key];
			if ( val.length > 0 ) form_fields[key] = val;
		}
	} else {
		pkg.ok = false;
		pkg.mess.push("can't find form: " + form_name);
	}

	// Specific form data
	for (let key in dat) {
		form_fields[key] = dat[key];
	}
	
	// Check url 
	let form_url = form_fields.form_url;
	if (typeof form_url != "undefined") {
		pkg.url = form_url;
		delete form_fields.form_url;
	} else {
		pkg.ok = false;
		pkg.mess.push("form url not found: " + form_url);
	}

	// Check method
	let form_method = form_fields.form_method;
	if (form_method=="get" || form_method=="post" ) {
		pkg.method = form_method;
		delete form_fields.form_method;
	} else {
		pkg.ok = false;
		pkg.mess.push("form method not found: " + form_method);
	}

	// Check attn
	if (!form_fields.attn || form_fields.attn=="") {
		form_fields.attn = form_name;
	}

	// Form type
	if (typeof form_fields.form_type != "undefined") {
		pkg.type = form_fields.form_type;
		delete form_fields.form_type;
	}

	// Don't need form name
	delete form_fields.form_name;

	// Build Form Data Object
	var fd = new FormData();
	for (let key in form_fields) {
		let val = form_fields[key] + ''; // Make sure it's a string
		fd.append(key, val);
	}
	
	pkg.form_fields = form_fields;
	pkg.form_data = fd;

	m("pkg",pkg);
	return pkg;
}


// Send Actual HTTP request ==========
export const sendHttpRequest = (pkg) => {

	m("sending http request...");
	m(pkg);
	
	// Set wait flag, get wait_id
	store.dispatch('api/toggleWait').then (response => {
		const api_wait_id = response;

		let state = store.getters["api/state"];
		let source = state.source;
		let full_url = source.url + source[pkg.type] + pkg.url;

		m("sending http request: " + api_wait_id + ": " + full_url);

		if (pkg.method == "post") {
			Vue.http.post(full_url, pkg.form_data)
			.then(response => {
				fetchPass(response, api_wait_id);
			  }, response => {
				fetchFail(response, api_wait_id);
			  });
		} else {
			Vue.http.get(full_url)
			.then(response => {
				fetchPass(response, api_wait_id);
			  }, response => {
				fetchFail(response, api_wait_id);
			  });
		}

	});


}


// Fetch communication fail
const fetchFail = (rsp, api_wait_id) => {
	m("fetch fail");
	store.dispatch('api/toggleWait', api_wait_id);
	m(rsp);
	showPopMess("Error Fetching Request", "err", rsp.bodyText);

	const data = {
		step: "fetch fail",
		trx: "error",
		mess: rsp.bodyText,
	}
	store.dispatch("app/updTrxStatus", data,{ root: true });


}

// Fetch JSON parse fail
const fetchJsonFail = (text) => {
	m("fetch JSON fail");
	showPopMess("Fetch JSON Fail", "err", text);
}


// Fetch communication pass
const fetchPass = (rsp, api_wait_id) => {
	m("fetch pass");
	store.dispatch('api/toggleWait', api_wait_id);
	m(rsp);

	let json = '';
	try {
		json = JSON.parse(rsp.bodyText);
	} catch (e) {
		let len = Math.min(200, rsp.bodyText.length);
		json = {
			com: '001',
			trx: '201',
			cols: [],
			rows: [],
			mess: ['Err parsing JSON response', e.message, rsp.bodyText.substr(0,len)],
			attn: 'no parse'
		};
		showPopMess("JSON Parse Fail", "err", json.mess);

	} finally {
		if (json.com && json.trx) {

			if (json.com=='100' && json.trx=='100') {
				trxPass(json);
			} else {
				trxFail(json);
			}
		} else {
			fetchJsonFail(rsp.bodyText);
		}
	}

}


// Transaction fail
const trxFail = (json) => {
	m("trx fail");
	m(json);
	showPopMess("Transaction Fail", "err", json.mess);

	const data = {
		step: "trx fail",
		trx: "error",
		mess: json.mess,
	}
	store.dispatch("app/updTrxStatus", data,{ root: true });


}


// Transaction pass
const trxPass = (json) => {
	m("trx pass");
	m(json);

	let recset = Utils.convert2Recordset(json.cols, json.rows);
	m("recset: ", recset);
	let pagerData = {};
	let recsetData = {};
	let payload = {};

	switch(json.attn) {
		case "init_cats_list":
			recsetData = {
				list: recset,
			}
			store.dispatch("app/loadCats", recsetData);
			// store.dispatch("app/initTaskPass", "init_cats_list");
			break;
		case "arts_list":
			pagerData = {
				begRec: json.meta.beg,
				endRec: json.meta.end,
				qtyRecs: json.meta.qty,
				totRecs: json.meta.tot,
			}; 
			store.dispatch("app/setPager", pagerData);

			recsetData = {
				list: recset,
			}
			store.dispatch("app/loadArts", recsetData);
			break;
		case "art_pix":
			recsetData = {
				step: "current",
				list: recset,
			}
			store.dispatch("app/loadPix", recsetData);
			break;
		case "adm_save":
			m('api utils: adm save caught');
			payload = {
				step: "current",
				trx: json.trx,
				mess: json.mess,
			}
			store.dispatch("app/postComplete", payload);
			// showPopMess("Success", "ok", json.mess);
			break;
		case "art_post": 
			m("api utils: art post caught");
			payload = {
				step: "upload",
				trx: json.trx,
				mess: json.mess,
			}
			store.dispatch("app/postComplete", payload);
			break;
		case "mess_post": 
			m("api utils: mess post caught");
			payload = {
				step: "contact",
				trx: json.trx,
				mess: json.mess,
			}
			store.dispatch("app/postComplete", payload);
			break;
		case "mail_sweep": 
			m("api utils: mail sweep caught");
			payload = {
				step: "sweep",
				trx: json.trx,
				mess: json.mess,
			}
			store.dispatch("app/postComplete", payload);
			break;
		case "site_stats": 
			m("api utils: site stats caught");
			m("json", json);
			payload = {
				step: "stats",
				trx: json.trx,
				mess: json.mess,
				cols: json.cols,
				rows: json.rows,
			}
			store.dispatch("app/postComplete", payload);
			break;

		default:
			m("api utils: attn not found: ", json.attn);
	}

}


const showPopMess = (title, type, mess) => {
	m("showPopMess: ", mess);

	let payload = {
		popType: "win",
		popTitle: title,
		compName: "UniMess",
		compData: {
			title: title,
			messType: type,
			mess: mess,
		}
	};
	eventBus.$emit("popup", payload);			
};


export const buildArtObject = (rec) => {
	m("api utils build art obj");
	const obj = {
		xdzanderart: {
			item_id		:rec.itemId,
			pix_id		:rec.pixId,
			cat_id		:rec.catId,
			live		:rec.live,
			stage		:rec.stage,
			merit		:rec.merit,
			credit		:rec.credit,
			title		:rec.title,
			summ_text	:'',
			full_text	:rec.fullTxt,
			descr		:rec.descr,
			notes		:rec.notes
		}
	};
	return obj;
};


export const buildPixObject = (pix) => {
	m("api utils build pix obj");
	const a = [];
	for (var i=0; i<pix.length; i++) {
		a.push ({
			item_id		:pix[i].itemId,
			live		:pix[i].live,
			sort_key	:pix[i].sortKey,
			stage		:pix[i].stage,
			merit		:pix[i].merit
		});
	}
	return {
		qbrogglepix: a,
	};
};




